'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _formatAddress = require('../../shared/formatAddress');

var _formatAddress2 = _interopRequireDefault(_formatAddress);

var _getShopData2 = require('../../shared/getShopData');

var _getShopData3 = _interopRequireDefault(_getShopData2);

var _replaceLang = require('../../shared/replaceLang');

var _replaceLang2 = _interopRequireDefault(_replaceLang);

var _mapApi = require('../../shared/mapApi');

var _sortAddressData = require('../../shared/sortAddressData');

var _sortAddressData2 = _interopRequireDefault(_sortAddressData);

var _ButtonTooltip = require('../ButtonTooltip/ButtonTooltip');

var _ButtonTooltip2 = _interopRequireDefault(_ButtonTooltip);

var _DropdownList = require('../DropdownList/DropdownList');

var _DropdownList2 = _interopRequireDefault(_DropdownList);

require('./ShopBlock.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISPLAY_TYPE_MOBILE = 0;
var DISPLAY_TYPE_DESKTOP = 1;

var ShopBlock = function (_Component) {
  (0, _inherits3.default)(ShopBlock, _Component);

  function ShopBlock() {
    (0, _classCallCheck3.default)(this, ShopBlock);
    return (0, _possibleConstructorReturn3.default)(this, (ShopBlock.__proto__ || (0, _getPrototypeOf2.default)(ShopBlock)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShopBlock, [{
    key: 'encode',
    value: function encode(string) {
      return encodeURIComponent(string.replace(' ', '+'));
    }
  }, {
    key: 'timeConvert',
    value: function timeConvert(time) {
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? ' AM' : ' PM';
        time[0] = +time[0] % 12 || 12;
      }
      return time.join('');
    }
  }, {
    key: 'formatHours',
    value: function formatHours(hours, specialHours, publicHolidays, locale) {
      var _this2 = this;

      var hoursList = [];
      var specialHoursList = [];
      var today = new Date();
      if (hours) {
        R.mapObjIndexed(function (day, index) {
          hoursList.push(_react2.default.createElement(
            'li',
            { key: index, className: (0, _classname2.default)('text-capitalize', { 'bold': today.getDay() == index }) },
            _this2.props.localize((0, _moment2.default)().weekday(index)).format('dddd'),
            ' :',
            day.length > 0 && day.map(function (hour, i) {
              var text = ' ';

              if (i !== 0) {
                text = text.concat(" / ");
              }

              if (locale.indexOf('en') === -1) {
                text = text.concat(hour.from + " - " + hour.to);
              } else {
                text = text.concat(_this2.timeConvert(hour.from) + " - " + _this2.timeConvert(hour.to));
              }

              return text;
            }),
            publicHolidays[index] && _react2.default.createElement(
              'span',
              { className: 'text-no-capitalize' },
              ' (',
              _this2.props.__('ShopBlock|publicHolidays'),
              ')'
            ),
            day.length === 0 && _react2.default.createElement(
              'span',
              null,
              ' ',
              _this2.props.__('ShopBlock|Closed')
            )
          ));
        })(hours);
      }

      hoursList.push(hoursList.shift());

      if (specialHours) {
        specialHoursList = specialHours.map(function (specialHour, index) {
          var formattedDate = _moment2.default.unix(specialHour.date);
          var formattedHours = [];

          if (specialHour.hours) {
            formattedHours = specialHour.hours.map(function (hour) {
              return _this2.props.__('ShopBlock|from') + ' ' + hour.from + ' ' + _this2.props.__('ShopBlock|to') + ' ' + hour.to;
            });
          }

          return _react2.default.createElement(
            'div',
            { key: index, className: 'ShopBlock__specialHours' },
            _this2.props.__('ShopBlock|Special hours'),
            ' ',
            _this2.props.localize(formattedDate).format('dddd LL'),
            ' ',
            formattedHours.join(' ' + _this2.props.__('ShopBlock|and') + ' ')
          );
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        specialHoursList,
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            { className: 'bold' },
            this.props.__('ShopBlock|Opening time'),
            ' : '
          ),
          hoursList
        )
      );
    }
  }, {
    key: 'getHour',
    value: function getHour(hours, today, locale) {
      if (locale.indexOf('en') === -1) {
        return hours[today.getDay()][hours[today.getDay()].length - 1].to;
      }
      return this.timeConvert(hours[today.getDay()][hours[today.getDay()].length - 1].to);
    }
  }, {
    key: 'formatHoursTitle',
    value: function formatHoursTitle(hours, today, locale) {
      return _react2.default.createElement(
        'span',
        null,
        hours[today.getDay()].length > 0 && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            null,
            this.props.__('ShopBlock|Open'),
            ': '
          ),
          this.props.__('ShopBlock|Today until %(hour)s', { hour: this.getHour(hours, today, locale) })
        ),
        hours[today.getDay()].length === 0 && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            null,
            this.props.__('ShopBlock|Closed today')
          )
        )
      );
    }
  }, {
    key: 'formatDropdownContent',
    value: function formatDropdownContent(universes) {
      var _this3 = this;

      var universesList = [];

      if (universes && universes.length > this.universesToDisplay) {
        universesList = universes.map(function (universe, index) {
          return _react2.default.createElement(
            'li',
            { key: index, className: (0, _classname2.default)('text-capitalize') },
            (0, _replaceLang2.default)(universe.localeLabels, universe.defaultLabel, _this3.props.countryCode, _this3.props.lang)
          );
        }).filter(function (universe) {
          return universe;
        });
      }

      if (universesList.length > 0) {
        return _react2.default.createElement(
          'ul',
          null,
          universesList
        );
      } else {
        return false;
      }
    }
  }, {
    key: 'formatDropdownTitle',
    value: function formatDropdownTitle(universes, title) {
      var _this4 = this;

      var universesList = [];

      if (universes) {
        universesList = universes.map(function (universe, index) {
          if (index < _this4.universesToDisplay - 1 || index === _this4.universesToDisplay - 1 && universes.length <= _this4.universesToDisplay) {
            return (0, _replaceLang2.default)(universe.localeLabels, universe.defaultLabel, _this4.props.countryCode, _this4.props.lang);
          }
          if (index === _this4.universesToDisplay - 1 && universes.length > _this4.universesToDisplay) {
            return (0, _replaceLang2.default)(universe.localeLabels, universe.defaultLabel, _this4.props.countryCode, _this4.props.lang) + '...';
          }
        }).filter(function (universe) {
          return universe;
        });
      }

      if (universesList.length > 0) {
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            null,
            title,
            ': '
          ),
          ' ',
          universesList.join(', ')
        );
      } else {
        return false;
      }
    }
  }, {
    key: 'getItineraryLink',
    value: function getItineraryLink(name, street, street1, zip, city, state) {
      var link = void 0;
      var origin = this.props.departure;
      var destination = (0, _formatAddress2.default)(street, street1, zip, city, state);

      if (this.props.displayType === DISPLAY_TYPE_MOBILE) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          link = _react2.default.createElement('a', {
            href: 'http://www.google.com/maps/dir/?api=1' + (origin ? '&origin=' + this.encode(origin) : '') + '&destination=' + this.encode(destination),
            className: 'ShopBlock__icon icon icon-directions',
            target: '_blank',
            title: this.props.__('ShopBlock|Directions'),
            'aria-label': this.props.__('ShopBlock|DirectionsAria', { shopName: name })
          });
        } else if (origin) {
          name = name || '终点';
          link = _react2.default.createElement('a', {
            href: 'http://api.map.baidu.com/direction?origin=' + origin + '&destination=latlng:' + this.props.shop.lat + ',' + this.props.shop.lng + '|name:' + name + '&mode=driving&output=html&src=dior&region=' + city,
            className: 'ShopBlock__icon icon icon-directions',
            target: '_blank',
            title: this.props.__('ShopBlock|Directions'),
            'aria-label': this.props.__('ShopBlock|DirectionsAria', { shopName: name })
          });
        }
      } else {
        link = _react2.default.createElement(_ButtonTooltip2.default, {
          className: (0, _classname2.default)("ShopBlock__icon icon", { 'icon-directions': !this.props.isItineraryVisible }, { 'icon-directions-full': this.props.isItineraryVisible }),
          onClick: this.onClickIcon.bind(this, this.props.itineraryCallback),
          title: this.props.__('ShopBlock|Directions'),
          'aria-label': this.props.__('ShopBlock|DirectionsAria', { shopName: name })
        });
      }

      return link;
    }
  }, {
    key: 'onClick',
    value: function onClick(event) {
      event.preventDefault();
      this.props.triggerCallback();
    }
  }, {
    key: 'onClickIcon',
    value: function onClickIcon(callback, event) {
      event.preventDefault();
      callback();
    }
  }, {
    key: 'sortUniverses',
    value: function sortUniverses(a, b) {
      if (a.parentOrder !== b.parentOrder) {
        return a.parentOrder - b.parentOrder;
      } else {
        return a.order - b.order;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      this.universesToDisplay = 2;

      var today = new Date();
      var shop = this.props.shop;

      var _getShopData = (0, _getShopData3.default)(shop, this.props.countryCode),
          shopName = _getShopData.shopName,
          shopStreet = _getShopData.shopStreet,
          shopStreet1 = _getShopData.shopStreet1,
          shopZipCode = _getShopData.shopZipCode,
          shopCity = _getShopData.shopCity,
          shopState = _getShopData.shopState,
          countryCode = _getShopData.countryCode;

      var address = this.props.shop && (0, _sortAddressData2.default)(this.props.locale, countryCode, shopZipCode, shopCity, shopStreet, shopStreet1, shopState);

      var formatted_hours = void 0;
      var formatted_hours_title = void 0;
      if (shop.showSchedules === '1' && shop.calculatedOpeningHours) {
        formatted_hours = this.formatHours(shop.calculatedOpeningHours, shop.specialHours, shop.publicHolidays || [], this.props.locale);
        formatted_hours_title = this.formatHoursTitle(shop.calculatedOpeningHours, today, this.props.locale);
      }

      var formatted_universes = void 0;
      var formatted_universes_title = void 0;
      if (shop.subUniverses && shop.subUniverses.length > 0) {
        var sortedSubUniverses = shop.subUniverses.sort(this.sortUniverses);
        formatted_universes = this.formatDropdownContent(sortedSubUniverses);
        formatted_universes_title = this.formatDropdownTitle(sortedSubUniverses, this.props.__('ShopBlock|Universes'));
      }

      var formatted_services = void 0;
      var formatted_services_title = void 0;
      if (shop.services && shop.services.length > 0) {
        formatted_services = this.formatDropdownContent(shop.services);
        formatted_services_title = this.formatDropdownTitle(shop.services, this.props.__('ShopBlock|Services'));
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classname2.default)('ShopBlock', { 'is-selected': this.props.isSelected }), id: 'ShopBlock-' + this.props.shop.id },
        _react2.default.createElement(
          'div',
          { className: 'ShopBlock__content' },
          _react2.default.createElement(
            'h4',
            { className: 'ShopBlock__element ShopBlock__title' },
            _react2.default.createElement(
              'button',
              { onClick: this.onClick.bind(this) },
              this.props.number && _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'sr-only' },
                  this.props.__('ShopBlock|ResultNumber', { number: this.props.number }),
                  ' ',
                  '\xA0'
                ),
                _react2.default.createElement(
                  'span',
                  {
                    className: (0, _classname2.default)("ShopBlock__number", { 'is-selected': this.props.isSelected }),
                    'aria-hidden': 'true'
                  },
                  this.props.number
                )
              ),
              shopName && _react2.default.createElement(
                'span',
                null,
                shopName
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'ShopBlock__element ShopBlock__address-block' },
            _react2.default.createElement(
              'ul',
              { className: 'ShopBlock__address' },
              address.map(function (line, index) {
                return line && line.length > 0 && _react2.default.createElement(
                  'li',
                  { key: index },
                  line
                );
              }),
              shop.phoneNumber && shop.phoneNumberPrefix && _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  {
                    className: 'ShopBlock__element ShopBlock__tel',
                    href: 'tel: ' + shop.phoneNumberPrefix + shop.phoneNumber.replace(/ /g, '')
                  },
                  '(',
                  shop.phoneNumberPrefix,
                  ') ',
                  shop.phoneNumber
                )
              )
            ),
            this.props.distance && _react2.default.createElement(
              'div',
              { className: 'ShopBlock__distance' },
              this.props.distance
            )
          ),
          formatted_hours && formatted_hours_title && _react2.default.createElement(_DropdownList2.default, {
            id: 'shopHours',
            title: formatted_hours_title,
            content: formatted_hours,
            closed: this.props.isItineraryVisible
          }),
          formatted_universes_title && _react2.default.createElement(_DropdownList2.default, {
            id: 'shopUniverses',
            title: formatted_universes_title,
            content: formatted_universes,
            closed: this.props.isItineraryVisible
          }),
          formatted_services_title && _react2.default.createElement(_DropdownList2.default, {
            id: 'shopServices',
            title: formatted_services_title,
            content: formatted_services,
            closed: this.props.isItineraryVisible
          }),
          _react2.default.createElement(
            'div',
            { className: 'ShopBlock__icons' },
            this.getItineraryLink(shopName, shopStreet, shopStreet1, shopZipCode, shopCity, shopState),
            shop.onlineBooking && !(shop.showContact === "1" && shop.apiKeyBooxi) && _react2.default.createElement(
              _ButtonTooltip2.default,
              {
                Component: 'a',
                className: 'ShopBlock__icon icon icon-calendar',
                title: this.props.__('ShopBlock|Make an appointment'),
                'aria-label': this.props.__('ShopBlock|Make an appointment'),
                href: shop.onlineBooking
              },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }),
              _react2.default.createElement('span', { className: 'path4' }),
              _react2.default.createElement('span', { className: 'path5' })
            ),
            shop.showContact === "1" && shop.apiKeyBooxi && _react2.default.createElement(
              _ButtonTooltip2.default,
              {
                className: 'ShopBlock__icon icon icon-calendar',
                onClick: this.onClickIcon.bind(this, this.props.calendarCallback),
                title: this.props.__('ShopBlock|Make an appointment'),
                'aria-label': this.props.__('ShopBlock|Make an appointment')
              },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }),
              _react2.default.createElement('span', { className: 'path4' }),
              _react2.default.createElement('span', { className: 'path5' })
            ),
            shop.showContact === "1" && !shop.apiKeyBooxi && !shop.onlineBooking && _react2.default.createElement(
              _ButtonTooltip2.default,
              {
                Component: 'a',
                className: 'ShopBlock__icon icon icon-calendar',
                title: this.props.__('ShopBlock|Make an appointment'),
                'aria-label': this.props.__('ShopBlock|Make an appointment'),
                href: '/' + this.props.locale + '/contact-couture'
              },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }),
              _react2.default.createElement('span', { className: 'path4' }),
              _react2.default.createElement('span', { className: 'path5' })
            ),
            _react2.default.createElement(_ButtonTooltip2.default, {
              className: 'ShopBlock__icon icon icon-share',
              onClick: this.onClickIcon.bind(this, this.props.shareCallback),
              title: this.props.__('ShopBlock|Share'),
              'aria-label': this.props.__('ShopBlock|Share')
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classname2.default)({ 'hidden-xs-up': !this.props.isItineraryVisible }) },
          this.props.children
        )
      );
    }
  }]);
  return ShopBlock;
}(_react.Component);

ShopBlock.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  localize: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  api: _propTypes2.default.object,
  calendarCallback: _propTypes2.default.func,
  countryCode: _propTypes2.default.string,
  departure: _propTypes2.default.string,
  displayType: _propTypes2.default.number,
  distance: _propTypes2.default.string,
  isItineraryVisible: _propTypes2.default.bool,
  isSelected: _propTypes2.default.bool,
  itineraryCallback: _propTypes2.default.func,
  lang: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  number: _propTypes2.default.number,
  shareCallback: _propTypes2.default.func,
  shop: _propTypes2.default.object,
  triggerCallback: _propTypes2.default.func
};

ShopBlock.defaultProps = {
  api: null,
  calendarCallback: function calendarCallback() {},
  countryCode: 'INT',
  departure: '',
  displayType: DISPLAY_TYPE_DESKTOP,
  distance: '',
  isItineraryVisible: false,
  isSelected: false,
  itineraryCallback: function itineraryCallback() {},
  lang: 'en',
  locale: 'en_int',
  number: 0,
  shareCallback: function shareCallback() {},
  shop: {},
  triggerCallback: function triggerCallback() {}
};

exports.default = (0, _reactTranslate.withTranslator)()(ShopBlock);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/ShopBlock/ShopBlock.js
// module id = 1177
// module chunks = 0